import React from "react";

import clsx from "clsx";
import {
  Formik,
  Form as FormikForm,
  FormikFormProps,
  FormikHelpers,
  FormikValues,
} from "formik";
import { Persist } from "formik-persist";

import { makeStyles } from "@material-ui/core";

import { trackEvent } from "@ip-utils";

import Field from "./Field";
import Grid from "./Grid";
import Presets from "./Presets";

const useStyles = makeStyles({
  loading: {
    opacity: 0.65,
    pointerEvents: "none",
  },
});

interface Props extends FormikFormProps {
  initialValues?: {};
  loading: boolean;
  storage?: string;
  onSubmit: (values: FormikValues, formik: FormikHelpers<FormikValues>) => void;
}

export default function Form({
  children,
  initialValues = {},
  loading,
  storage,
  onSubmit,
  ...props
}: Props) {
  const classes = useStyles();

  function handleSubmit(
    values: FormikValues,
    formik: FormikHelpers<FormikValues>
  ) {
    trackEvent("Form", "Submit");
    onSubmit(values, formik);
  }

  const className = clsx({
    [classes.loading]: loading,
  });

  return (
    <Formik initialValues={initialValues} onSubmit={handleSubmit} {...props}>
      <FormikForm className={className}>
        {children}
        {storage && (
          <Persist
            name={`${window.location.hash.replace("#", "")}-${storage}`}
          />
        )}
      </FormikForm>
    </Formik>
  );
}

Form.Field = Field;
Form.Grid = Grid;
Form.Presets = Presets;
